import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany, references } from '@apexdesigner/schema-tools';

export const alternateStudent = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    created: z.coerce.date().nullable().optional().hidden().describe('Created'),

    inactiveEffectiveDate: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe(
        "Inactive Effective Date - Dropped as of this date; filtered from the unscheduled-attendance pick list from then on (opp 7261). Set through the markInactive behavior's confirmation dialog, not edited directly",
      ),

    statusNotes: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Status Notes - Context for status changes (why dropped, ...)'),

    termId: z.number().hidden().describe('Foreign key to Term'),

    studentId: z
      .number()
      .presentAs('reference')
      .describe('Foreign key to Student'),

    term: belongsTo('Term'),

    student: references('Student'),

    notAvailables: hasMany('NotAvailable'),

    availabilities: hasMany('AlternateStudentAvailability'),
  })
  .describe(
    'A stand-by enrollment joining a student to a term, with its own per-slot availability.',
  )
  .as('AlternateStudent');

export { alternateStudent as alternateStudentSchema };
